import React from "react";
import { X, MapPin, Globe } from "lucide-react";
import { Button } from "./Button";
import { useTranslation } from "react-i18next";

interface ProfessionalInviteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLocalProfessionalClick: () => void;
  onInternationalProfessionalClick: () => void;
}

const ProfessionalInviteModal: React.FC<ProfessionalInviteModalProps> = ({
  isOpen,
  onClose,
  onLocalProfessionalClick,
  onInternationalProfessionalClick,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-xl font-bold text-red-600">{t("professionalInviteModal.title")}</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="space-y-4 mb-6">
          <p className="text-gray-700">
            {t("professionalInviteModal.receiveOffers")}
          </p>
          <p className="text-gray-700">
            {t("professionalInviteModal.searchProfessionals")}
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            className="w-full flex items-center justify-center gap-2 py-3"
            onClick={onLocalProfessionalClick}
          >
            <MapPin className="h-4 w-4" />
            {t("professionalInviteModal.findLocalProfessional")}
          </Button>
          <Button
            variant="outline"
            className="w-full flex items-center justify-center gap-2 py-3"
            onClick={onInternationalProfessionalClick}
          >
            <Globe className="h-4 w-4" />
            {t("professionalInviteModal.findInternationalProfessional")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalInviteModal;
